import { useCallback } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { IssuesPage } from "@/components/issues/list/issues-page";
import { parseIssuesSearch, type IssuesSearch } from "@/components/issues/list/search";

export const Route = createFileRoute("/_app/$workspaceSlug/$projectSlug/issues/")({
  // The view and the filters live in the URL and nowhere else, so a reload,
  // the back button and a link someone was sent all give the same page.
  // Whatever the URL says, this returns a page that can be drawn: it never
  // throws.
  validateSearch: (search: Record<string, unknown>): IssuesSearch => parseIssuesSearch(search),
  component: IssuesRoute,
});

function IssuesRoute() {
  const { projectSlug } = Route.useParams();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const setSearch = useCallback(
    (next: IssuesSearch, options?: { replace?: boolean }) =>
      void navigate({ search: next, replace: options?.replace }),
    [navigate],
  );
  // Keyed by project: the selection, the folded groups and the display are one project's.
  return <IssuesPage key={projectSlug} search={search} onSearchChange={setSearch} />;
}
